import React from 'react';
import PageNotFound from '../../components/core-ui/PageNotFound/404';

const NotFound = () => {
    return (
        <div>
            <PageNotFound />
        </div>
    );
};

export default NotFound;
